import {EmbedCodeExtractor} from "./types"

/**
 * Patterns of Tik::WebEmbedService::PreProcessor::FacebookJs
 * (backend/mediaservice/lib/tik/web_embed_service/pre_processor/facebook_js.rb).
 *
 * Sample input:
 *   <div class="fb-post" data-href="https://www.facebook.com/zuck/posts/10102577175875681" data-width="500"></div>
 */
const PATTERNS = [
  /class=["']fb-post["'].*data-href=['"](\S+)['"]/i
]

/** Port of PreProcessor::FacebookJs — extracts the `data-href` URL from fb-post JS-SDK embed divs. */
export const facebookJsPreProcessor: EmbedCodeExtractor = (input: string): string | null => {
  for(const pattern of PATTERNS) {
    const matchData = pattern.exec(input)
    if(matchData) {
      return matchData[1] ?? ""
    }
  }
  return null
}
